import { Component, OnInit } from '@angular/core';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.css']
})
export class MyOrdersComponent implements OnInit {

  myOrders = [];

  constructor(private resolver: ResolverService) { }

  ngOnInit(): void {
    this.resolver.getMyOrders();
  }

  getMyOrders(){
    return this.resolver.getDependency('shopifyOrder');
  }

  getStatusClass(status: string) {
    switch (status) {
      case "paymentPending": return "status-pending";
      case "shipped": return "status-shipped";
      case "delivered": return "status-delivered";
      default: return "";
    }
  }

  loading(){
    return this.resolver.isLoading('shopifyOrder');
  }

  getObjectValues(obj: any): any[] {
    return obj ? Object.values(obj) : []; // Converts object to array
  }

  getOrderField(orderInfo,field){
    let json;
    json = JSON.parse(orderInfo);
    return json[field];
  }
  

  getOrderProducts(orderInfo){
    let json;
    json = JSON.parse(orderInfo);
    return json['orderProducts'];
  }

}
